import objectToGetParams from "./objectToGetParams";

export default function ({ platform, url, text, hashtags }) {
  switch (platform) {
    default:
    case "whatsapp":
      return (
        "https://api.whatsapp.com/send" +
        objectToGetParams({
          text: text ? text + " " + url : url
        })
      );
    case "facebook":
      return (
        "https://www.facebook.com/sharer/sharer.php" +
        objectToGetParams({
          u: url,
          quote: text,
          hashtag: hashtags
        })
      );
    case "twitter":
      return (
        "https://twitter.com/share" +
        objectToGetParams({
          url,
          text,
          hashtags: hashtags.slice(1)
        })
      );
  }
}